/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCompany } from '../../models/api-response-company';
import { Company } from '../../models/company';

export interface UpdateCompanyByRef$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body?: {
'company': Company;
'companyLogo'?: Blob;
}
}

export function updateCompanyByRef(http: HttpClient, rootUrl: string, params: UpdateCompanyByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCompany>> {
  const rb = new RequestBuilder(rootUrl, updateCompanyByRef.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCompany>;
    })
  );
}

updateCompanyByRef.PATH = '/v1/api/admin-ui/company/update/{reference}';
